import React, { useState } from "react";
import { useFetchSubscriptionData } from "../../../apis/settingsApis";
import RoleToggle from "../../Dashboard/_components/RoleToggle";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import UpdatePaymentModal from "./UpdatePaymentModal";
import { IconCheck } from "@tabler/icons-react";

const PlansData = [
  {
    name: "Basic",
    price: "500",
    disc: "Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development.",
    PlanFeature: [
      "Fully customized to your business requirements",
      "Scalable and future-proof architecture",
      "Robust security measures to protect your data",
      "Comprehensive support and maintenance",
      "Secure, cloud-based, and high-performance solutions",
    ],
  },
  {
    name: "Standard",
    price: "1000",
    disc: "Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development.",
    PlanFeature: [
      "Fully customized to your business requirements",
      "Scalable and future-proof architecture",
      "Robust security measures to protect your data",
      "Comprehensive support and maintenance",
      "Secure, cloud-based, and high-performance solutions",
    ],
  },
  {
    name: "Premium ",
    price: "2000 ",
    disc: "Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development.",
    PlanFeature: [
      "Fully customized to your business requirements",
      "Scalable and future-proof architecture",
      "Robust security measures to protect your data",
      "Comprehensive support and maintenance",
      "Secure, cloud-based, and high-performance solutions",
    ],
  },
];

const Plans: React.FC = () => {
  const { data } = useFetchSubscriptionData();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeRole = searchParams.get("tab") || "Subscription";

  const handleRoleChange = (role: string) => {
    setSearchParams({ tab: role });
  };

  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  return (
    <>
      {/* Subscription Overview */}
      <div className="grid-cols-3 gap-6 grid pt-2  ">
        {PlansData?.map((item: any, index: number) => (
          <div className="bg-white rounded-2xl border  p-4 2xl:space-y-6 space-y-4 group cursor-pointer transition-all duration-150 hover:bg-gradient-to-tr from-70% from-[#fff] to-[#FBD037]">
            <div className="space-y-2 w-full">
              <div className="flex items-center justify-between">
                <h2 className="font-bold 2xl:text-lg text-md uppercase tracking-tighter">
                  {item.name}
                </h2>
              </div>
              <p className="text-black/70 2xl:text-base text-sm break-all tracking-tight]">
                Lorem ipsum is a dummy or placeholder text commonly used in
                graphic design, publishing, and web development.
              </p>
            </div>

            <div>
              <h1 className="2xl:text-3xl text-2xl font-bold">
                {item.price} SAR
                <span className="2xl:text-base text-sm font-semibold uppercase">
                  /Per Month
                </span>
              </h1>
            </div>

            <div className="space-y-4">
              <p className="text-black/80 font-medium 2xl:text-sm text-sm uppercase">
                What's included?
              </p>
              <ul className="space-y-2">
                {item.PlanFeature?.map((point: string, index: number) => (
                  <li key={index} className="flex items-start space-x-2">
                    <div className="bg-[#FBD037] size-6 rounded-full flex items-center justify-center flex-shrink-0">
                      <IconCheck size={18} stroke={2} color="white" />
                    </div>
                    <p className="2xl:text-base text-sm">{point}</p>
                  </li>
                ))}
              </ul>
            </div>
            <div className="">
              <button onClick={()=> navigate('/payment')} className="bg-[#FBD037] text-base rounded-full font-medium text-[#000000] border border-[#FBD037]  px-6 py-2  w-full hover:bg-[#FBD037]/90 transition-all duration-150">
                Choose Plan
              </button>
            </div>
          </div>
        ))}
      </div>

      <UpdatePaymentModal onClose={() => setOpen(false)} open={open} />
    </>
  );
};

export default Plans;
